// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import type { AISmartButtonSidebarAPI } from '../ai-smart-button';

import type { ObjectSidebar } from './types/object-sidebar-types';

export const isObjectSidebar = (
	sidebarApi: AISmartButtonSidebarAPI | ObjectSidebar,
): sidebarApi is ObjectSidebar => {
	return (
		'state' in sidebarApi && 'actions' in sidebarApi && 'changeHeaderElements' in sidebarApi.actions
	);
};
